export default class {
    static getPoints() {
      // TODO Move this to a shared variable
      const activeConfigurator = document.getElementById('activeConfiguratorId').value;
       return $.getJSON("getpoints", { activeConfigurator: activeConfigurator })
           .then(data => {
               data = $.parseJSON(JSON.stringify(data));
               return data;
           });
    }
    static getProducts() {
      const activeConfigurator = document.getElementById('activeConfiguratorId').value;
        return $.getJSON("getproducts", { activeConfigurator: activeConfigurator })
           .then(data => {
               data = $.parseJSON(JSON.stringify(data));
               return data;
           });
    }
    static getCategories() {
      const activeConfigurator = document.getElementById('activeConfiguratorId').value;
        return $.getJSON("getcategories", { activeConfigurator: activeConfigurator })
            .then(data => {
                data = $.parseJSON(JSON.stringify(data));
                return data;
            });
        }
    static getDepths() {
      const activeConfigurator = document.getElementById('activeConfiguratorId').value;
        return $.getJSON("getdepths", { activeConfigurator: activeConfigurator })
            .then(data => {
                data = $.parseJSON(JSON.stringify(data));
                return data;
            });
        }
    static getSearch() {
      const activeConfigurator = document.getElementById('activeConfiguratorId').value;
        return $.getJSON("getsearch", { activeConfigurator: activeConfigurator })
            .then(data => {
                data = $.parseJSON(JSON.stringify(data));
                return data;
            });
        }
    static getFilter() {
      const activeConfigurator = document.getElementById('activeConfiguratorId').value;
        return $.getJSON("getfilter", { activeConfigurator: activeConfigurator })
            .then(data => {
                data = $.parseJSON(JSON.stringify(data));
                return data;
            });
    }

    static getEnabledIdList(list) {
        return list.filter((item) => {
            return item.Selected;
        }).map((item) => { return item.Id });
    }
    
    static getIdList(list){
        return list.map((item) => {
            return item.Id
        });
    }

    static findItem(source, comparison){
        return source.some((item) => {
            return comparison.includes(item);
        });
    }
    static noSelected(list) {
        return list.every(item => item.Selected === false);
    }
}